import locationMarker from "./location-arrow-solid-full.svg";
import rotationArrow_left from "./arrow-rotate-left-solid-full.svg";
import rotationArrow_right from "./arrow-rotate-right-solid-full.svg";

export const icons = {
  locationMarker: locationMarker,
  rotationArrow_left: rotationArrow_left,
  rotationArrow_right: rotationArrow_right,
};
